// notEmpty can be used to filter out empty objects in an array.
// It will result in a new array type.
export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue => {
  return value != null;
};
